import { TrainingAPI } from "../../api/TrainingAPI";

const trainingAPI = new TrainingAPI();

export const BREAKDOWN_SET_LOADING = "[BREAKDOWN]_SET_LOADING";
export const BREAKDOWN_SET_FILTER = "[BREAKDOWN]_SET_FILTER";
export const BREAKDOWN_SET_DATA = "[BREAKDOWN]_SET_DATA";

export const setBreakdownLoading = (loading) => ({
  type: BREAKDOWN_SET_LOADING,
  payload: loading,
});

export const setBreakdownFilterDrills = (drills) => ({
  type: BREAKDOWN_SET_FILTER,
  payload: { drills },
});

export const setBreakdownFilterDate = (date) => ({
  type: BREAKDOWN_SET_FILTER,
  payload: { date },
});

export const setBreakdownFilterPosition = (position) => ({
  type: BREAKDOWN_SET_FILTER,
  payload: { position },
});

export const setBreakdownFilterPlayerGroups = (playerGroups) => ({
  type: BREAKDOWN_SET_FILTER,
  payload: { playerGroups },
});

export const setBreakdownFilterSession = (session) => ({
  type: BREAKDOWN_SET_FILTER,
  payload: { session },
});

export const setBreakdownData = (data) => ({
  type: BREAKDOWN_SET_DATA,
  payload: data,
});

export const getBreakdownData = () => {
  return async (dispatch, getState) => {
    const { filter } = getState().breakdown;
    if (!filter.date) {
      console.warn("[getBreakdownData] Skipping request — filter.date is undefined");
      return;
    }
    await dispatch(setBreakdownLoading(true));
    try {
      const trainings = await trainingAPI.getBreakdownTrainings(
        filter.date,
        filter.position,
        filter.playerGroups,
        filter.session,
        filter.drills,
        true
      );
      await dispatch(setBreakdownData(trainings));
    } catch (e) {
      console.error(e);
    }
    await dispatch(setBreakdownLoading(false));
  };
};
